import { Moment } from 'moment'
import React from 'react'

import { Person } from '../../App/store/features/person/IPerson'
import { CalendarLoader } from '../CalendarLoader'
import { CalendarToolbar } from '../CalendarToolbar'
import { DayHeader } from '../DayHeader'
import { PersonHeaders } from '../PersonHeaders'

import {
  CalendarHeaderWrapper,
  DayComponentsWrapper,
  CalendarDayWrapper,
} from './style'

interface IProps {
  personsList: Person[]
  filteredPersons: Person[]
  selectedDate: Moment
  startDate: Moment
  amountOfDays: 1 | 3 | 7
  onDateChanged: (date: Moment) => void
}

export const CalendarHeader = ({
  selectedDate,
  startDate,
  onDateChanged,
  personsList,
  filteredPersons,
  amountOfDays,
}: IProps) => {
  const dayComponents = []

  for (let i = 0; i < amountOfDays; i += 1) {
    dayComponents.push(
      <CalendarDayWrapper key={`calendarHeader${i}`}>
        <DayHeader date={startDate.clone().add(i, 'days')} />
        <PersonHeaders
          filteredPersons={filteredPersons}
          amountOfDays={amountOfDays}
        />
      </CalendarDayWrapper>,
    )
  }

  return (
    <CalendarHeaderWrapper>
      <CalendarLoader />
      <CalendarToolbar
        persons={personsList}
        date={selectedDate}
        onDateChanged={onDateChanged}
        amountOfDays={amountOfDays}
      />
      <DayComponentsWrapper>{dayComponents}</DayComponentsWrapper>
    </CalendarHeaderWrapper>
  )
}
